export const ACCESS_TOKEN = 'access_token';
export const DEFAULT_PAGE_SIZE = 10;

export const BOARD_NOTICE_MODULE_NO = 1;
export const BOARD_INQUIRY_MODULE_NO = 2;
export const BOARD_QNA_MODULE_NO = 5;
export const BOARD_ARCHIVE_MODULE_NO = 4;
export const BOARD_FAQ_MODULE_NO = 3;

// 전용 페이지가 있는 게시판(module_no → 경로). 그 외 게시판은 /community/board/:moduleNo 로 표시
export const BOARD_PATHS = {
  [BOARD_NOTICE_MODULE_NO]: '/community/notice',
  [BOARD_INQUIRY_MODULE_NO]: '/community/inquiry',
  [BOARD_FAQ_MODULE_NO]: '/community/faq',
  [BOARD_QNA_MODULE_NO]: '/community/qna',
  [BOARD_ARCHIVE_MODULE_NO]: '/community/archive',
};